import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

import IUserGet from 'api/interfaces/users/IUserGet';
import IUsersState from 'interfaces/store/IUsersState';

import {
  FETCH_USER,
  FETCH_USERS,
  SET_ACCESS_TOKEN,
  SET_MSAL_ACCOUNT,
  SET_MSAL_INSTANCE,
} from './types';

const initialState: IUsersState = {
  accessToken: null,
  current: null,
  msalInstance: null,
  msalAccount: null,
  users: [],
};

export default (
  state: IUsersState = initialState,
  action: {
    accessToken: null | string;
    type: string;
    user: IUserGet | null;
    users: IUserGet[] | null;
    msalInstance: IPublicClientApplication | null;
    msalAccount: AccountInfo | null;
  }
): IUsersState => {
  if (action.type === FETCH_USER.SUCCESS) {
    return {
      ...state,
      current: action.user,
    };
  }

  if (action.type === FETCH_USERS.SUCCESS) {
    return {
      ...state,
      users: action.users,
    };
  }

  if (action.type === SET_ACCESS_TOKEN) {
    return {
      ...state,
      accessToken: action.accessToken,
    };
  }

  if (action.type === SET_MSAL_INSTANCE) {
    return {
      ...state,
      msalInstance: action.msalInstance,
    };
  }

  if (action.type === SET_MSAL_ACCOUNT) {
    return {
      ...state,
      msalAccount: action.msalAccount,
    };
  }

  return state;
};
